var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 13.333V10m0-3.333h.009M18.084 10a8.333 8.333 0 11-16.667 0 8.333 8.333 0 0116.667 0z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxOSAyMCIgZmlsbD0iY3VycmVudCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNzUwMzMgMTMuMzMzNFYxME05Ljc1MDMzIDYuNjY2NjlIOS43NTg2Nk0xOC4wODM3IDEwQzE4LjA4MzcgMTQuNjAyNCAxNC4zNTI3IDE4LjMzMzQgOS43NTAzMyAxOC4zMzM0QzUuMTQ3OTUgMTguMzMzNCAxLjQxNjk5IDE0LjYwMjQgMS40MTY5OSAxMEMxLjQxNjk5IDUuMzk3NjUgNS4xNDc5NSAxLjY2NjY5IDkuNzUwMzMgMS42NjY2OUMxNC4zNTI3IDEuNjY2NjkgMTguMDgzNyA1LjM5NzY1IDE4LjA4MzcgMTBaIiBzdHJva2U9ImN1cnJlbnQiIGZpbGw9ImN1cnJlbnQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgInfo as ReactComponent };